import { z } from 'zod';
/**
 * The Reports Hub (spec §13.8). Which reports exist, and what each gathers,
 * is code; the parameters a reader chooses are validated here.
 */
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'A date is YYYY-MM-DD.');
export const reportParamsSchema = z.object({
    from: isoDate.optional(),
    to: isoDate.optional(),
    projectId: z.string().uuid().optional(),
    year: z.coerce.number().int().min(2000).max(2100).optional(),
    periodId: z.string().uuid().optional(),
});
export const REPORT_EXPORT_FORMATS = ['csv', 'xlsx', 'pdf'];
export const reportExportFormatSchema = z.enum(REPORT_EXPORT_FORMATS);
//# sourceMappingURL=reports.js.map